module.exports = __webpack_public_path__ + "img/27.242105f5.jpg";